import useWindowSize from '@customHooks/useWindowSize';
import { memo, useState } from 'react';
import CartBtn from './components/CartBtn';
import MiniCart from './components/MiniCart';
import './index.scss';

const HeaderCart = () => {
  const { isDesktop } = useWindowSize();
  const [isShow, setIsShow] = useState(false);
  const showMiniCart = () => isDesktop && setIsShow(true);
  const hideMiniCart = () => isDesktop && setIsShow(false);
  return (
    <div
      className={'basket-container'}
      onMouseEnter={showMiniCart}
      onMouseLeave={hideMiniCart}
    >
      <CartBtn
        hideMiniCart={hideMiniCart}
        isDesktop={isDesktop}
        isShow={isShow}
      />
      <MiniCart isShow={isShow} hideMiniCart={hideMiniCart} />
    </div>
  );
};

export default memo(HeaderCart);
